import { Roles } from "../../constants/roles";
import { FormBase } from "../../util/form-base-form";

export class AvatarForm extends FormBase {
    public getModal(root: ParentNode = document): HTMLElement | null {
        if (root instanceof HTMLElement && root.getAttribute("data-role") === Roles.AVATAR_MODAL) {
            return root;
        }
        return this.queryElement(root, `[data-role="${Roles.AVATAR_MODAL}"]`, HTMLElement);
    }

    public getModalUserId(root: ParentNode = document): number | null {
        const rawUserId =
            root instanceof HTMLElement && root.getAttribute("data-role") === Roles.AVATAR_MODAL
                ? root.getAttribute("data-user-id")
                : (this.getModal(root)?.getAttribute("data-user-id") ?? null);

        const normalizedUserId = Number(rawUserId);
        return Number.isInteger(normalizedUserId) && normalizedUserId > 0 ? normalizedUserId : null;
    }

    public getAvatarInput(root: ParentNode): HTMLInputElement | null {
        return this.getInput(root, `[data-role="${Roles.AVATAR_INPUT}"]`);
    }

    public getAvatarPreview(root: ParentNode): HTMLImageElement | null {
        return this.queryElement(root, `[data-role="${Roles.AVATAR_PREVIEW}"]`, HTMLImageElement);
    }

    public getSaveButton(root: ParentNode): HTMLButtonElement | null {
        return this.getButton(root, `[data-role="${Roles.SAVE_AVATAR_BTN}"]`);
    }

    public getPickButton(root: ParentNode): HTMLButtonElement | null {
        return this.getButton(root, `[data-role="${Roles.AVATAR_IMAGE_PICK}"]`);
    }

    public getOpenButton(root: ParentNode = document): HTMLButtonElement | null {
        return this.getButton(root, `[data-role="${Roles.OPEN_AVATAR_MODAL}"]`);
    }

    public getCloseButton(root: ParentNode): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.CLOSE_AVATAR_MODAL}"]`, HTMLElement);
    }

    public getCancelButton(root: ParentNode): HTMLButtonElement | null {
        return this.getButton(root, `[data-role="${Roles.CANCEL_AVATAR_BTN}"]`);
    }

    public getOverlay(root: ParentNode): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.AVATAR_MODAL_OVERLAY}"]`, HTMLElement);
    }

    public getAvatarImages(root: ParentNode = document): HTMLImageElement[] {
        return this.queryElements(root, `[data-role="${Roles.AVATAR_IMAGE}"]`, HTMLImageElement);
    }
}

export const avatarForm = new AvatarForm();
